import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

import { LT_DOMAIN } from '../../../pages/constants';

export const useGetWhitelabelDomain = (): string => {
  const state = useConstructorContextState();

  return get(state, ['whitelabelDomain'], LT_DOMAIN);
};
